import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FileSaverService } from 'ngx-filesaver';
import { ApiService } from 'src/app/api.service';
import { UiService } from 'src/app/ui/ui.service';
import { SessionService } from "src/app/session.service";
import { takeUntil } from "rxjs/operators";
import moment from 'moment';
import { Subject } from "rxjs";
import { find, groupBy, map, flatten, orderBy } from "lodash";
import { AppService } from "../apps/app.service";

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements OnInit {
  filterForm!: FormGroup;
  private onComponentDestroy = new Subject();
  data: any;
  periods: any = [{
    label: 'Day',
    value: 'day'
  },{
    label: 'Week',
    value: 'week'
  },{
    label: 'Month',
    value: 'month'
  },{
    label: 'Quarter',
    value: 'quarter'
  },{
    label: 'Year',
    value: 'year'
  }];
  period: string = 'day';
  canUpdate: boolean = false;
  apps: any;
  selectedApps: any;

  constructor(
    private route: ActivatedRoute,
    private uiService: UiService,
    private APIService: ApiService,
    private fileSaver: FileSaverService,
    private SessionService: SessionService,
    private AppService: AppService,
  ) {}

  ngOnInit(): void {
    
    this.apps = orderBy(flatten(map(this.SessionService.accounts, (a)=> {
      return a.apps;
    })), 'name');

    this.selectedApps = [find(this.SessionService.apps, (a)=>{
      return this.SessionService.currentAppValue!.id == a.id;
    })];

    this.filterForm = new FormGroup({
      startDate: new FormControl(this.route.snapshot.data.start),
      endDate: new FormControl(this.route.snapshot.data.end),
      group: new FormControl(find(this.periods, (p)=>{
        return p.value == 'day';
      })),
      apps: new FormControl(this.selectedApps)
    });

    this.filterForm.controls.startDate.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((value) => {
        this.canUpdate = true;
      });

    this.filterForm.controls.endDate.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((value) => {
        this.canUpdate = true;
      });

      this.filterForm.controls.group.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((value) => {
        this.canUpdate = true;
      });

      this.filterForm.controls.apps.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((value) => {
        this.canUpdate = true;
      });

      this.groupData(this.route.snapshot.data.stats);

      
    
  }

  groupData(data: any) {
    let grouped: any = groupBy(data, 'id');
    var dat: any = [];
    Object.keys(grouped).forEach((g)=>{
      dat.push({
        id: grouped[g][0].id,
        name: grouped[g][0].name,
        data: grouped[g]
      });
    });
    this.data = orderBy(dat, 'name');
  }

  removeApp(event: any) {

  }

  update(forExport: boolean) {

    this.AppService.getStats(
      this.SessionService.currentAccountValue!.accountID,
      this.SessionService.currentAppValue!.id,
      this.filterForm.controls.startDate.value,
      this.filterForm.controls.endDate.value,
      this.filterForm.controls.group.value.value,
      map(this.selectedApps, 'id'),
      forExport
    ).pipe(takeUntil(this.onComponentDestroy)).subscribe(
      res => {
        if(!forExport){
          this.canUpdate = false;
          this.groupData(res);
          this.period = this.filterForm.controls.group.value.value;
        } else {
          this.fileSaver.save((<any>res), moment().format("[Stats-]YYYY-MM-DD-HH-mm-ss[.xlsx]"));
        }
        
      },
      error => {
        console.error('fetch error:', error)
      }, 
      () => {
          //console.log('Completed file download.')
      }
    );

  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  periodLabel(period: string) {

    switch (this.period) {
      case 'day':
        return moment(period).format('MMM DD, YYYY');
      case 'week':
        return 'Week of ' + moment(period).format('MMM DD, YYYY');
      case 'month':
        return moment(period).format('MMM, YYYY');
      case 'quarter':
        return 'Q' + moment(period).quarter() + ', ' + moment(period).format('YYYY');
      case 'year':
        return moment(period).format('YYYY');
      default:
        return moment(period).format('MMM DD, YYYY');
    }
    
  }

}
